import { getContentFilterDefaults } from "pages/Rules/Form/Filters/Action/utils";
import { FieldFormat, SectionConfig } from "../../types";
import { selectActionFilter } from "../selectors";
import { getItemKeyByValue } from "./helpers";

const ATTACHMENT_TYPE: FieldFormat = {
  enum: {
    IMAGE: "actionFilters.attachmentType.IMAGE",
    AUDIO: "actionFilters.attachmentType.AUDIO",
    TEXT: "actionFilters.attachmentType.TEXT",
    VIDEO: "actionFilters.attachmentType.VIDEO",
    APPLICATION: "actionFilters.attachmentType.APPLICATION",
  },
};

// Defaults taken whole from the form so both stay in sync.
const FILTER_DEFAULTS = getContentFilterDefaults();

const config: SectionConfig = {
  section: "actionFilter",
  titleKey: "filters.action",
  selector: selectActionFilter,
  properties: {
    attachmentSize: {
      label: "confirmRuleUpdates.actionFilterChanges.attachmentSize.size",
      format: { resolve: "attachmentSize" },
    },
    excludeAttachmentExtensions: {
      label:
        "confirmRuleUpdates.actionFilterChanges.excludeAttachmentExtensions",
      getItemKey: getItemKeyByValue,
    },
    includeAttachmentExtensions: {
      label:
        "confirmRuleUpdates.actionFilterChanges.includeAttachmentExtensions",
      getItemKey: getItemKeyByValue,
    },
    excludeAttachmentNames: {
      label: "confirmRuleUpdates.actionFilterChanges.excludeAttachmentNames",
      getItemKey: getItemKeyByValue,
    },
    includeAttachmentNames: {
      label: "confirmRuleUpdates.actionFilterChanges.includeAttachmentNames",
      getItemKey: getItemKeyByValue,
    },
    excludeAttachmentTypes: {
      label: "confirmRuleUpdates.actionFilterChanges.excludeAttachmentTypes",
      format: ATTACHMENT_TYPE,
      getItemKey: getItemKeyByValue,
    },
    includeAttachmentTypes: {
      label: "confirmRuleUpdates.actionFilterChanges.includeAttachmentTypes",
      format: ATTACHMENT_TYPE,
      getItemKey: getItemKeyByValue,
    },
    includeRfc822: {
      label: "includeRfc822Label",
      format: "boolean",
      default: FILTER_DEFAULTS.includeRfc822,
    },
    excludeInlineImages: {
      label: "excludeInlineImages",
      format: "boolean",
      default: FILTER_DEFAULTS.excludeInlineImages,
    },
    includeZipWithPassword: {
      label: "includeZipWithPasswordLabel",
      format: "boolean",
      default: FILTER_DEFAULTS.includeZipWithPassword,
    },
    excludeMultipartReport: {
      label: "excludeMultipartReportLabel",
      format: "boolean",
      default: FILTER_DEFAULTS.excludeMultipartReport,
    },
    filterPolicyId: {
      label: "filterPolicy.toggle",
      format: { resolve: "filterPolicy" },
    },
    includeTnef: {
      label: "includeTnefLabel",
      format: "boolean",
      default: FILTER_DEFAULTS.includeTnef,
    },
  },
};

export default config;
